import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	form: {
		width: '100%',
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
	header: {
		display: 'flex',
	},
	formContainer: {
		display: '',
	},
	formElementLabel: {
		marginBottom: '1.25rem',
		marginTop: '0.5rem',
		minWidth: '66%',
		maxWidth: '100%',
		textAlign: 'left',
		
	},
}));

export default useStyles;
